import {Directive, ElementRef, Input, OnChanges, Renderer2} from '@angular/core';
import {of} from 'rxjs';
import {filter, finalize, timeoutWith} from 'rxjs/internal/operators';

import {ATTRIBUTE_MVEL_ALIAS} from '../../app.constants';

import {MvelEvalResult, MvelService} from './mvel.service';

@Directive({
  selector: '[gpMvel]'
})
export class MvelDirective implements OnChanges {

  @Input()
  public mvelAliases: Array<string>;

  @Input()
  public contractId: number;

  public mvelEvalFinished = false;

  constructor(private elt: ElementRef,
              private renderer: Renderer2,
              private mvelService: MvelService) {
  }

  ngOnChanges() {
    if (this.contractId && this.mvelAliases && this.mvelAliases.length > 0) {
      this.mvelEvalFinished = true;
      setTimeout(() => this.init(), 10);
      this.mvelService
        .eval(this.contractId, this.mvelAliases)
        .pipe(
          filter(Boolean),
          timeoutWith(3000, of()),
          finalize(() => {
            this.mvelEvalFinished = false;
            setTimeout(() => this.hideLoader(), 10);
          })
        )
        .subscribe((result: MvelEvalResult) => this.setPropertiesByRenderer(result));
    }
  }

  // TODO to find another way to change the value
  private setPropertiesByRenderer(result: MvelEvalResult): void {
    const nodeList = this.elt.nativeElement.querySelectorAll(`[${ATTRIBUTE_MVEL_ALIAS}]`);
    nodeList.forEach((node: any) => {
      const aliasName = node.getAttribute(`${ATTRIBUTE_MVEL_ALIAS}`);
      if (node.classList.contains('fa-spinner')) {
        node.style.display = 'none';
      } else if (!node.classList.contains('ng-dirty') && result.results && result.results.hasOwnProperty(aliasName)) {
        this.renderer.setProperty(node, 'value', result.results[aliasName]);
        node.dispatchEvent(new Event('input'));
      } else if (result.errors && result.errors.hasOwnProperty(aliasName)) {
        console.warn(`mvel alias error :  ${aliasName} =>  ${result.errors[aliasName]}`);
      }
    });
  }

  private init() {
    this.initLoader();
    this.detectChange();
  }

  private initLoader() {
    this.changeVisibiltyLoader(true);
  }

  private hideLoader() {
    this.changeVisibiltyLoader(false);
  }

  private changeVisibiltyLoader(visible: boolean) {
    const nodeList = this.elt.nativeElement.querySelectorAll(`[${ATTRIBUTE_MVEL_ALIAS}].fa-spinner`);
    nodeList.forEach((node: HTMLElement) => node.style.display = visible ? 'inline-block' : 'none');
  }

  private hideLoaderFor(node: HTMLElement) {
    const aliasName = node.getAttribute(`${ATTRIBUTE_MVEL_ALIAS}`);
    const loader = this.elt.nativeElement.querySelector(`[${ATTRIBUTE_MVEL_ALIAS}='${aliasName}'].fa-spinner`);
    if (loader) {
      loader.style.display = 'none';
    }
  }

  private detectChange() {
    const nodeList = this.elt.nativeElement.querySelectorAll(`[${ATTRIBUTE_MVEL_ALIAS}]`);
    nodeList.forEach((node: any) => {
      this.renderer.listen(node, 'input', () => this.hideLoaderFor(node));
    });
  }
}
